import Cookies from 'js-cookie'

export const getClientId = () => {
  const gaCookie = Cookies.get('_ga')
  if (gaCookie) {
    return gaCookie.split('.').slice(-2).join('.')
  }
  return `${Math.random().toString(36).substring(2, 10)}.${Date.now()}`
}

export function initDataLayer() {
  window.dataLayer = window.dataLayer || []
}

export function pushToDataLayer(event, additionalData = {}) {
  initDataLayer()
  const eventData = {
    event,
    ...additionalData
  }
  window.dataLayer.push(eventData)
}

export function trackAiHelperClick() {
  pushToDataLayer('ai_helper_click')
}

export function trackStoryClick(storyId) {
  pushToDataLayer('story_click', {
    story_id: storyId
  })
}

export function trackStoryView(storyId) {
  pushToDataLayer('story_view', {
    story_id: storyId
  })
}
